import { SHOW_NOTIFICATION, CLEAR_NOTIIFCATION } from "../actions/types";

export default (state = {}, action) => {
    switch (action.type) {
        case SHOW_NOTIFICATION:
            return action.payload;
        default:
            return state;
    }
};
